import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTagWrap from "../OrderTagWrap";
import { Tooltip } from "antd";

/**
 * 微信小店平台标签组件
 * 包含所有微信小店相关的标签逻辑
 */
export default function useChannelshopTagIcons(order: OrderDTO, orderTagSet: Set<OrderTag>, shop: ShopDTO) {
    const icons = [];

    if (orderTagSet.has(OrderTag.CHANNELSHOP_QUALITY_INSPECTION)) {
        icons.push(
            <Tooltip
                key={OrderTag.CHANNELSHOP_QUALITY_INSPECTION}
                title={<span>送检订单：需将商品先寄到微信小店质检仓进行质检，质检通过后由质检仓将商品寄给买家</span>}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.CHANNELSHOP_QUALITY_INSPECTION}
                />
            </Tooltip>,
        );
    }

    return icons;
}
